import { render, staticRenderFns } from "./MoreActions.vue?vue&type=template&id=92c7c5d8&scoped=true&"
import script from "./MoreActions.vue?vue&type=script&lang=js&"
export * from "./MoreActions.vue?vue&type=script&lang=js&"
import style0 from "./MoreActions.vue?vue&type=style&index=0&id=92c7c5d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c7c5d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92c7c5d8')) {
      api.createRecord('92c7c5d8', component.options)
    } else {
      api.reload('92c7c5d8', component.options)
    }
    module.hot.accept("./MoreActions.vue?vue&type=template&id=92c7c5d8&scoped=true&", function () {
      api.rerender('92c7c5d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/MoreActions.vue"
export default component.exports